var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-page',{attrs:{"fetch-endpoint":_vm.fetchEndpoint}},[(_vm.model)?_c('integration-settings-form',{ref:"form",attrs:{"model":_vm.model,"integration":_vm.integration,"save-endpoint":_vm.saveEndpoint}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23609d42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/pages/IntegrationSettings.vue
// module id = null
// module chunks = 